import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackage } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

export interface ISetPackageDefaultActivationRequest {
  packageDefaultActivationRequest: { defaultActivation: boolean };
}

export interface ISetPackageDefaultActivationResponse {
  package?: IPackage;
}

export class SetPackageDefaultActivationService {
  public static setPackageDefaultActivation(
    packageLuid: string,
    defaultActivation: boolean,
  ): Promise<ISetPackageDefaultActivationResponse> {
    return makeJsonRestApiRequest<ISetPackageDefaultActivationRequest, ISetPackageDefaultActivationResponse>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'PUT',
        endpoint: `${PACKAGES_PATH}/${packageLuid}/default-activation`,
      },
      request: { packageDefaultActivationRequest: { defaultActivation } },
    });
  }
}
